export const UsersBreadcrumb = [
  { label: "Dashboard", path: "/dashboard" },
  { label: "Users", path: "/users" },
];
